import "./new-collection.scss";
import { throttle } from "lodash";

if (!window.dAgency) window.dAgency = {};
window.dAgency.initNewCollection = async (context) => {
  if (!context) return;
  const stickyBar = context.querySelector(".collection__sticky-bar");
  if (!stickyBar) return;

  const throttledResize = throttle(() => {
    const stickyTop = parseInt(window.getComputedStyle(stickyBar).top);
    const currentTop = stickyBar.getBoundingClientRect().top;
    stickyBar.classList.toggle("is-sticky", currentTop === stickyTop);
  }, 100);
  window.addEventListener("scroll", throttledResize);
};

if (document.readyState != "loading") {
  [].forEach.call(
    document.querySelectorAll(".collection__container"),
    (context) => window.dAgency.initNewCollection(context)
  );
} else {
  document.addEventListener("DOMContentLoaded", () => {
    [].forEach.call(
      document.querySelectorAll(".collection__container"),
      (context) => window.dAgency.initNewCollection(context)
    );
  });
}
